<template lang="pug">
section.LndServices
  h2(v-html="header || L.header")

  ul.d-flex
    li(v-for="item of L.list")
      .__logo: img(:src="logos[item.$logo]", :alt="item.$logo")
      //- .__line
      .d-flex.--middle.__stat(v-html="item.text2 || ''")
      .__desc(v-html="item.text || ''")

</template>
<script>
import content, { logos } from 'content';

export default {
  name: 'LndServices',

  static: () => ({
    logos,
    L: content.services,
  }),

  props: {
    header: String,
  },
};

</script>
<style>
.LndServices {
  h2 {
    margin-bottom: 92px;
  }

  ul {
    justify-content: space-between;
    --gap-h: calc(70 / var(--vw-scale));
    --gap-v: calc(70 / var(--vw-scale));
  }

  li {
    width: 180px;
    flex-basis: 300px;
    /*flex-grow: 2;*/
    flex-shrink: 2;

    list-style: none;

    &:nth-child(1) img {
      height: 24px;

      opacity: .8;
    }
    &:nth-child(2) img {
      height: 14px;

      opacity: .8;
    }
    &:nth-child(3) img {
      height: 18px;

      opacity: .7;
    }
  }

  .__line {
    height: 40px;
    margin-bottom: 30px;
    padding-left: 20px;
    overflow: hidden;

    color: #888;
    font-size: 12px;
    line-height: 18px;
    white-space: break-spaces;

    /*border-left: 1px solid var(--accent-c);*/
  }

  .__stat {
    height: 80px;
    margin-bottom: 35px;

    color: var(--text-c);
    font-size: 14px;

    border: 1px solid var(--sep-c);
    border-width: 1px 0;

    span {
      display: flex;
      align-items: center;
      height: calc(100% - 30px);
      margin-right: 20px;
      padding-right: 20px;

      font-size: 32px;

      border-right: 1px solid var(--sep-c);
    }
  }

  .__logo {
    display: block;
    height: 24px;
    margin-bottom: 50px;

    /*opacity: .9;*/

    transition: filter .2s;
  }

  .__desc {
    line-height: 30px;
  }
}

@media (max-width: 739px) {
  .LndServices {
    ul {
      justify-content: flex-start;
      flex-wrap: wrap;

      > li {
        max-width: max(375px, 50%);
        width: 100%;
        margin-bottom: 80px;
        /*flex-grow: 2;*/
      }
    }
  }
}
</style>
